import request from './request';
import requestWithoutTimeout from './requestWithoutTimeout';

const discountSettingService = {
  get: (params) => request.get('dashboard/admin/discount-settings', { params }),
  getAll: (params) =>
    request.get('dashboard/admin/discount-settings/paginate', { params }),
  selectPaginate: (params) =>
    request.get('dashboard/admin/discount-settings/select-paginate', { params }),
  export: (params) =>
    requestWithoutTimeout.get('dashboard/admin/discount-settings/export', {
      params,
    }),
  getById: (id, params) =>
    requestWithoutTimeout.get(`dashboard/admin/discount-settings/${id}`, {
      params,
    }),
  create: (params) =>
    request.post('dashboard/admin/discount-settings', {}, { params }),
  update: (id, params) =>
    request.put(`dashboard/admin/discount-settings/${id}`, {}, { params }),
  delete: (params) =>
    request.delete(`dashboard/admin/discount-settings/delete`, { params }),
  search: (params) =>
    request.get(`dashboard/admin/discount-settings/search`, { params }),
  dropAll: () => request.get(`dashboard/admin/discount-settings/drop/all`),
  restoreAll: () =>
    request.get(`dashboard/admin/discount-settings/restore/all`),
};

export default discountSettingService;
